var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { ref: "ruleForm", attrs: { model: _vm.invoiceVoucher, rules: _vm.rules } },
    [
      _c("div", { staticClass: "simple-form flex col-2" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("开票方集团名称")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.invoiceVoucher.issuerRealName || ""))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("开票方公司名称")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.invoiceVoucher.issuerRealComName || ""))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("受票方集团名称")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "receiverRealComCode" } },
                [
                  _c("el-input", {
                    staticClass: "width-1-5x",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.invoiceVoucher.receiverRealName,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceVoucher, "receiverRealName", $$v)
                      },
                      expression: "invoiceVoucher.receiverRealName"
                    }
                  }),
                  _vm._v(" "),
                  _vm.settleProofId == null
                    ? _c(
                        "span",
                        {
                          staticClass: "swb-btn swb-btn-link",
                          on: { click: _vm.setRealCom }
                        },
                        [_vm._v("选择实体公司")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("受票方公司编码")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "receiverRealComCode" } },
                [
                  _c("el-input", {
                    staticClass: "width-1-5x",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.invoiceVoucher.receiverRealComCode,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceVoucher, "receiverRealComCode", $$v)
                      },
                      expression: "invoiceVoucher.receiverRealComCode"
                    }
                  }),
                  _vm._v(" "),
                  _vm.settleProofId == null
                    ? _c(
                        "span",
                        {
                          staticClass: "swb-btn swb-btn-link",
                          on: { click: _vm.setRealCom }
                        },
                        [_vm._v("选择实体公司")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("主体类型")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "invoiceSubjectType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.invoiceVoucher.invoiceSubjectType,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.invoiceVoucher,
                            "invoiceSubjectType",
                            $$v
                          )
                        },
                        expression: "invoiceVoucher.invoiceSubjectType"
                      }
                    },
                    _vm._l(_vm.invoiceSubjectTypeList, function(item) {
                      return _c("el-option", {
                        attrs: { label: item.text, value: item.value }
                      })
                    })
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("主体信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.invoiceTypeMaps[_vm.invoiceVoucher.invoiceType] || ""
                )
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-2" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("发票抬头")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c("el-form-item", { attrs: { prop: "invoiceTitle" } }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.invoiceVoucher.invoiceTitle || "无"))
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "swb-bth swb-btn-link",
                    on: { click: _vm.selectInvoiceInfo }
                  },
                  [_vm._v("选择")]
                )
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [
              _vm._v("受票方纳税识别号")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.invoiceVoucher.receiverTaxPayerNo || "无"))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("税率")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value " },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "taxRate" } },
                [
                  _vm.normalFlag
                    ? _c(
                        "el-select",
                        {
                          staticClass: "width-1-5x",
                          attrs: { placeholder: "请选择税率", clearable: "" },
                          on: {
                            change: function($event) {
                              _vm.changeActualAmount(true)
                            }
                          },
                          model: {
                            value: _vm.invoiceVoucher.taxRate,
                            callback: function($$v) {
                              _vm.$set(_vm.invoiceVoucher, "taxRate", $$v)
                            },
                            expression: "invoiceVoucher.taxRate"
                          }
                        },
                        _vm._l(_vm.fiscalTaxMarkList, function(item) {
                          return _c("el-option", {
                            key: item.rate,
                            attrs: { label: item.rate, value: item.rate }
                          })
                        })
                      )
                    : _c("el-input", {
                        staticClass: "width-1-5x",
                        on: {
                          blur: function($event) {
                            _vm.changeActualAmount(true)
                          }
                        },
                        model: {
                          value: _vm.invoiceVoucher.taxRate,
                          callback: function($$v) {
                            _vm.$set(_vm.invoiceVoucher, "taxRate", $$v)
                          },
                          expression: "invoiceVoucher.taxRate"
                        }
                      }),
                  _vm._v(" "),
                  _c("span", [_vm._v("%")])
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-2" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("实际价税合计")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "actualAmount" } },
                [
                  _c("el-input", {
                    staticClass: "width-1-5x",
                    attrs: { type: "number" },
                    on: {
                      change: function($event) {
                        _vm.changeActualAmount(false)
                      }
                    },
                    model: {
                      value: _vm.invoiceVoucher.actualAmount,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceVoucher, "actualAmount", $$v)
                      },
                      expression: "invoiceVoucher.actualAmount"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("元")])
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("价税合计")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [
              _vm._v(
                _vm._s(parseFloat(_vm.invoiceVoucher.amount || 0).toFixed(2))
              )
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("元")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("实际合计金额")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "actualNtxAmount" } },
                [
                  _c("el-input", {
                    staticClass: "width-1-5x",
                    attrs: { type: "number" },
                    on: {
                      change: function($event) {
                        _vm.changeActualNtxAmount()
                      }
                    },
                    model: {
                      value: _vm.invoiceVoucher.actualNtxAmount,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceVoucher, "actualNtxAmount", $$v)
                      },
                      expression: "invoiceVoucher.actualNtxAmount"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("元")])
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("合计金额")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "amount" } },
                [
                  _c("el-input", {
                    staticClass: "width-1-5x",
                    attrs: { type: "number" },
                    model: {
                      value: _vm.invoiceVoucher.ntxAmount,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceVoucher, "ntxAmount", $$v)
                      },
                      expression: "invoiceVoucher.ntxAmount"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("元")])
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("实际合计税额")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "actualTaxAmount" } },
                [
                  _c("el-input", {
                    staticClass: "width-1-5x",
                    attrs: { type: "number" },
                    on: {
                      change: function($event) {
                        _vm.changeActualTaxAmount()
                      }
                    },
                    model: {
                      value: _vm.invoiceVoucher.actualTaxAmount,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceVoucher, "actualTaxAmount", $$v)
                      },
                      expression: "invoiceVoucher.actualTaxAmount"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("元")])
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("合计税额")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-value width-1-5x" }, [
            _c("span", [
              _vm._v(
                _vm._s(parseFloat(_vm.invoiceVoucher.taxAmount || 0).toFixed(2))
              )
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("元")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form flex col-2" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", { staticClass: "required" }, [_vm._v("发票号")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "actualNo" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.invoiceVoucher.actualNo,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceVoucher, "actualNo", $$v)
                      },
                      expression: "invoiceVoucher.actualNo"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("发票代码")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "actualCode" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.invoiceVoucher.actualCode,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceVoucher, "actualCode", $$v)
                      },
                      expression: "invoiceVoucher.actualCode"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("实际开票日期")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "actualDate" } },
                [
                  _c("el-date-picker", {
                    staticClass: "width-1-5x",
                    attrs: { type: "date", placeholder: "实际开票日期" },
                    model: {
                      value: _vm.invoiceVoucher.actualDate,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceVoucher, "actualDate", $$v)
                      },
                      expression: "invoiceVoucher.actualDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("发票方式")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.invoiceVoucher.issueMethod,
                    callback: function($$v) {
                      _vm.$set(_vm.invoiceVoucher, "issueMethod", $$v)
                    },
                    expression: "invoiceVoucher.issueMethod"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("纸质发票")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("电子发票")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("全电发票")])
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("受票方联系电话")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "buyerLinkTel" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.invoiceVoucher.receiverContactTel,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceVoucher, "receiverContactTel", $$v)
                      },
                      expression: "invoiceVoucher.receiverContactTel"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("受票方联系地址电话")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "receiverAddrTel" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入地址 电话信息" },
                    model: {
                      value: _vm.invoiceVoucher.receiverAddrTel,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceVoucher, "receiverAddrTel", $$v)
                      },
                      expression: "invoiceVoucher.receiverAddrTel"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("受票方银行名称")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "buyerBankName" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.invoiceVoucher.receiverBankName,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceVoucher, "receiverBankName", $$v)
                      },
                      expression: "invoiceVoucher.receiverBankName"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("受票方银行账号")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "buyerAcctNo" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.invoiceVoucher.receiverAcctNo,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceVoucher, "receiverAcctNo", $$v)
                      },
                      expression: "invoiceVoucher.receiverAcctNo"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("受票方联系人姓名")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "buyerContactName" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.invoiceVoucher.receiverContactName,
                      callback: function($$v) {
                        _vm.$set(_vm.invoiceVoucher, "receiverContactName", $$v)
                      },
                      expression: "invoiceVoucher.receiverContactName"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("附件信息")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _c("div", { staticClass: "form-label" }, [
            _c("label", [_vm._v("附件信息")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c("swb-file-upload", {
                attrs: {
                  fileGroup: "image-goods",
                  onBeforeUpload: _vm.onBeforeUpload,
                  onProgress: _vm.onProgress,
                  onDone: _vm.onUploadDone,
                  multipleFile: false
                }
              }),
              _vm._v(" "),
              _vm.invoiceVoucher.fileUuid != null &&
              _vm.invoiceVoucher.fileUuid != ""
                ? _c(
                    "div",
                    { staticClass: "file-area clearfix" },
                    [
                      _c("swb-file-item", {
                        attrs: {
                          fileName: _vm.invoiceVoucher.fileExtName,
                          fileUuid: _vm.invoiceVoucher.fileUuid,
                          fileBrowseUrl: _vm.invoiceVoucher.fileBrowseUrl,
                          fileDownloadUrl: _vm.invoiceVoucher.fileBrowseUrl,
                          deletable: true,
                          onDelete: _vm.removeUpload
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45913ac7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45913ac7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/invoiceVoucher/InvoiceVoucherSave.vue
// module id = 2728
// module chunks = 0